import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ROOT_OG_DESCRIPTION, ROOT_OG_TITLE } from '../../shared-lib/utils/social-meta';
import { logout } from '../action/logout-action';

interface SEOState {
  title: string;
  description: string;
  image?: string;
}

const initialState: SEOState = {
  title: ROOT_OG_TITLE,
  description: ROOT_OG_DESCRIPTION,
  image: '',
};

const seoSlice = createSlice({
  name: 'seo',
  initialState,
  reducers: {
    setSEO: (state, action: PayloadAction<Partial<SEOState>>) => {
      return { ...state, ...action.payload };
    },
    resetSEO: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setSEO, resetSEO } = seoSlice.actions;
export default seoSlice.reducer; 